export default __webpack_public_path__ + "static/media/483e07f307a95ff1.e771247f6c03f63dd208b223969dc7e6.svg";